import { PublicUser } from '../users/types'

export default (user: PublicUser, userDeleted?: boolean) => {
  if (!user) return userDeleted ? 'User deleted' : 'System'
  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ')
  return (
    fullName ||
    user.username ||
    user.email ||
    (userDeleted ? 'User deleted' : 'System')
  )
}
